import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const addAddress = async (businessId, userId, payload) => {
  try {
    let resp = await http.post(
      `${URL}/address/${businessId}/${userId}`,
      payload
    );
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const getAddresses = async (businessId, userId) => {
  try {
    let resp = await http.get(`${URL}/address/${businessId}/${userId}`);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const updateAddress = async (businessId, userId, addressId, data) => {
  try {
    let resp = await http.put(
      `${URL}/address/${businessId}/${userId}/${addressId}`,
      data
    );
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const deleteAddress = async (businessId, userId, addressId) => {
  try {
    let resp = await http.delete(
      `${URL}/address/${businessId}/${userId}/${addressId}`
    );
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const INDIA_STATE_NAME_TO_CODE = {
  "Andaman and Nicobar Islands": "AN",
  "Andhra Pradesh": "AP",
  "Arunachal Pradesh": "AR",
  Assam: "AS",
  Bihar: "BR",
  Chandigarh: "CH",
  Chhattisgarh: "CT",
  "Dadra and Nagar Haveli": "DH",
  "Daman and Diu": "DH",
  Delhi: "DL",
  Goa: "GA",
  Gujarat: "GJ",
  Haryana: "HR",
  "Himachal Pradesh": "HP",
  "Jammu and Kashmir": "JK",
  Jharkhand: "JH",
  Karnataka: "KA",
  Kerala: "KL",
  Ladakh: "LA",
  Lakshadweep: "LD",
  "Madhya Pradesh": "MP",
  Maharashtra: "MH",
  Manipur: "MN",
  Meghalaya: "ML",
  Mizoram: "MZ",
  Nagaland: "NL",
  Odisha: "OR",
  Puducherry: "PY",
  Punjab: "PB",
  Rajasthan: "RJ",
  Sikkim: "SK",
  "Tamil Nadu": "TN",
  Telangana: "TG",
  Tripura: "TR",
  "Uttar Pradesh": "UP",
  Uttarakhand: "UT",
  "West Bengal": "WB",
};

export const fetchCityStateByPincode = async (pincode) => {
  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await res.json();

    if (data[0]?.Status === "Success" && data[0]?.PostOffice?.length) {
      const postOffice = data[0].PostOffice[0];
      console.log("post office", postOffice);
      const stateName = postOffice.State;
      const stateCode = INDIA_STATE_NAME_TO_CODE[stateName] || "";
      return {
        city: postOffice.District,
        state: stateCode,
      };
    }
    return null;
  } catch (error) {
    console.error("Pincode lookup failed", error);
    return null;
  }
};

const getFirstNonEmpty = (...values) =>
  values.find((value) => typeof value === "string" && value.trim().length > 0)?.trim() || "";

const getAddressLine1 = (address = {}, displayName = "") => {
  const candidate = getFirstNonEmpty(
    [address.house_number, address.road].filter(Boolean).join(" "),
    [address.building, address.road].filter(Boolean).join(", "),
    [address.amenity, address.road].filter(Boolean).join(", "),
    [address.suburb, address.neighbourhood].filter(Boolean).join(", "),
    displayName.split(",").slice(0, 3).join(", ")
  );

  return candidate || displayName;
};

const getLocality = (address = {}) =>
  getFirstNonEmpty(
    address.suburb,
    address.neighbourhood,
    address.city_district,
    address.quarter,
    address.hamlet,
    address.village,
    address.town,
    address.city
  );

const normalizePostalCode = (postalCode = "") => {
  const match = String(postalCode).match(/\d{6}/);
  if (match) {
    return match[0];
  }

  return String(postalCode).replace(/\D/g, "").slice(0, 6);
};

export const reverseGeocodeCoordinates = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&addressdetails=1&zoom=18&namedetails=1&extratags=1&accept-language=en`
    );

    if (!response.ok) {
      throw new Error("Reverse geocoding failed");
    }

    const data = await response.json();
    const address = data?.address || {};
    const stateName = getFirstNonEmpty(address.state, address.region, address.state_district);

    return {
      addressLine1: getAddressLine1(address, data?.display_name || ""),
      locality: getLocality(address),
      city: getFirstNonEmpty(
        address.city,
        address.town,
        address.village,
        address.county,
        address.state_district
      ),
      state: INDIA_STATE_NAME_TO_CODE[stateName] || stateName,
      pincode: normalizePostalCode(
        getFirstNonEmpty(address.postcode, data?.display_name || "")
      ),
      country: getFirstNonEmpty(address.country, "India"),
      displayName: data?.display_name || "",
      latitude: Number(data?.lat) || Number(latitude),
      longitude: Number(data?.lon) || Number(longitude),
    };
  } catch (error) {
    console.error("Reverse geocoding failed", error);
    return null;
  }
};